
export default interface IYearMonth {
    year: number;
    month: number;
}

const formatMonth = (m: number) => m < 10 ? `0${m}` : m;

export const formatYearMonth = (yearMonth: IYearMonth) =>
    `${yearMonth.year}-${formatMonth(yearMonth.month)}`;